import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["numCols"];
import styled from 'styled-components';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import { MDXLayoutContextProvider } from 'developer-docs-shared-components/context/MDXLayoutContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Flexboxified styles based on CMS `.row-fluid [class*=span]` 1280px min width
 * styles. Pared down slightly and adapted to our local system's breakpoints.
 *
 * @see https://developers.hubspot.com/docs/cms/building-blocks/templates#layout-css
 * @see https://cdn2.hubspot.net/hubfs/327485/Designers_Docs_2015/layout.css
 */
const Div = styled.div.withConfig({
  displayName: "DndModule__Div",
  componentId: "e8c3lp-0"
})(["", "{width:", ";}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT), ({
  numCols
}) => `${100 - (12 - numCols) * 8.547008547}%`);

/**
 * @deprecated
 * A CMS-extracted drag and drop (Dnd) module (a.k.a. component) with a set
 * width along a 12-column grid.
 *
 * These modules should not have expanded gutter functionality as the 12-col
 * styles interfere with the gutter styles.
 */
const DndModule = _ref => {
  let {
      numCols
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(MDXLayoutContextProvider, {
    value: false,
    children: /*#__PURE__*/_jsx(Div, Object.assign({}, rest, {
      numCols: numCols
    }))
  });
};
export default DndModule;